define('companiesDetailBodySubaccountRowView',[
  'module',
  'marionette',
  'underscore',
  'template!companiesDetailBodySubaccountRowView'
], function (
  module,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  module.exports = Marionette.ItemView.extend({
    template: Tpl,
    tagName: 'tr',
    className: 'subaccount-row clickable',

    triggers: {
      'click': 'selected'
    },

    serializeData: function () {
      var data = this.model.toJSON();
      return {
        endUserId: data.endUserId || data.code || '',
        name: data.name || '',
        firstName: data.firstName || '',
        lastName: data.lastName || '',
        email: data.email || '',
        city: data.city || ''
      };
    }
  });
});

